import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { Modal } from "@/components/modal";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Confirmation modal shown before removing a suggested action. */
export function ActionDeleteConfirm(_ref) {
  var opened = _ref.opened,
    isDeleting = _ref.isDeleting,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Modal, {
    opened: opened,
    onClose: onClose,
    title: t("label.delete_action_confirm_title", {
      defaultValue: "Remove this action?"
    }),
    size: "sm",
    closeTestId: "action-delete-modal-close",
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "action-delete-cancel",
      intent: "base",
      variant: "secondary",
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.ACTION_DELETE_CANCEL);
        onClose();
      },
      disabled: isDeleting
    }, t("button.cancel", {
      defaultValue: "Cancel"
    })), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "action-delete-confirm",
      intent: "urgent",
      variant: "primary",
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.ACTION_DELETE_CONFIRM);
        onConfirm();
      },
      loading: isDeleting
    }, isDeleting ? t("loading", {
      defaultValue: "Loading"
    }) : t("button.delete", {
      defaultValue: "Delete"
    })))
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-base text-sds-base-secondary"
  }, t("label.delete_action_confirm_body", {
    defaultValue: "This action will be removed from the suggestion."
  })));
}